import conf from 'src/conf/conf';
import { selectUserInfo } from 'src/store/selectors/userInfo';
import { I18n } from 'src/translations/i18n';
import broadcastActionsMap from 'src/store/broadcast/syncActionsList';
class ActionBroadcastChannel {
    static channel;
    static activeChannelName;
    static store;
    static run = (store, action) => {
        this.store = store;
        const newChannelName = this.getChannelName();
        if (!this.activeChannelName && newChannelName) {
            this.createChannel(newChannelName);
        }
        else if (this.activeChannelName && !newChannelName) {
            this.closeActiveChannel();
        }
        else if (this.activeChannelName !== newChannelName && !!newChannelName) {
            this.closeActiveChannel();
            this.createChannel(newChannelName);
        }
        if (this.channel) {
            this.handleAction(action);
        }
    };
    static getChannelName = () => {
        const state = this.store.getState();
        const { requestUrl, basename, clientId } = conf;
        const { CompanyId, UserId } = selectUserInfo(state);
        if (!CompanyId || !UserId)
            return '';
        return `store_${requestUrl}_${basename}_${clientId}_${navigator.userAgent}_${CompanyId}_${UserId}`;
    };
    static createChannel = (channelName) => {
        this.activeChannelName = channelName;
        this.channel = new BroadcastChannel(channelName);
        this.channel.onmessage = this.broadcastMessageHandler;
    };
    static closeActiveChannel = () => {
        this.channel?.close();
        this.activeChannelName = '';
    };
    static handleAction = (action) => {
        if (!action._noBroadcast && action.type in broadcastActionsMap) {
            this.sendAction(action);
        }
    };
    static sendAction = (action) => {
        const message = {
            ...action,
            _noBroadcast: true
        };
        this.channel?.postMessage(message);
    };
    static broadcastMessageHandler = (event) => {
        try {
            this.store?.dispatch({ ...event.data, _noBroadcast: true });
        }
        catch (e) {
            console.error(e);
            if (window.confirm(I18n.t('AppSyncError'))) {
                window.location.reload();
            }
        }
    };
}
export default ActionBroadcastChannel;
